var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagadan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 606.229,
    width: 481.55,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d4af38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#ffd90d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d4af38"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-745.662 -302.382) scale(1.32681)",
    gradientUnits: "userSpaceOnUse",
    id: "d",
    x1: 39.346,
    x2: 132.151,
    xlinkHref: "#a",
    y1: 221.856,
    y2: 173.998
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-1111.43 -1002.277) scale(1.32681)",
    gradientUnits: "userSpaceOnUse",
    id: "j",
    x1: 390.132,
    x2: 450.86,
    xlinkHref: "#b",
    y1: 608.509,
    y2: 552.527
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-1111.43 -1002.277) scale(1.32681)",
    gradientUnits: "userSpaceOnUse",
    id: "i",
    x1: 432.545,
    x2: 476.113,
    xlinkHref: "#a",
    y1: 600.504,
    y2: 600.504
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-1111.43 -1002.277) scale(1.32681)",
    gradientUnits: "userSpaceOnUse",
    id: "h",
    x1: 479.124,
    x2: 509.032,
    xlinkHref: "#b",
    y1: 557.543,
    y2: 590.984
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-59.61 -1495.42) scale(1.32681)",
    gradientUnits: "userSpaceOnUse",
    id: "g",
    x1: -124.177,
    x2: -116.778,
    xlinkHref: "#a",
    y1: 761.954,
    y2: 761.954
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(1493.606 94.745) scale(1.32681)",
    gradientUnits: "userSpaceOnUse",
    id: "f",
    x1: -759.195,
    x2: -751.795,
    xlinkHref: "#a",
    y1: 108.776,
    y2: 108.776
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "silver"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "silver"
    }
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-745.662 -106.17) scale(1.32681)",
    gradientUnits: "userSpaceOnUse",
    id: "n",
    x1: 228.877,
    x2: 314.685,
    xlinkHref: "#b",
    y1: 169.16,
    y2: 227.5
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-745.662 -204.276) scale(1.32681)",
    gradientUnits: "userSpaceOnUse",
    id: "m",
    x1: 228.877,
    x2: 314.685,
    xlinkHref: "#b",
    y1: 169.16,
    y2: 227.5
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-1113.13 -1002.277) scale(1.32681)",
    gradientUnits: "userSpaceOnUse",
    id: "l",
    x1: 405.036,
    x2: 454.58,
    xlinkHref: "#b",
    y1: 616.568,
    y2: 616.568
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-1113.13 -1002.277) scale(1.32681)",
    gradientUnits: "userSpaceOnUse",
    id: "k",
    x1: 456.638,
    x2: 506.183,
    xlinkHref: "#b",
    y1: 616.69,
    y2: 616.69
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-745.662 -302.382) scale(1.32681)",
    gradientUnits: "userSpaceOnUse",
    id: "e",
    x1: 228.877,
    x2: 314.685,
    xlinkHref: "#b",
    y1: 169.16,
    y2: 227.5
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-745.662 -302.382) scale(1.32681)",
    gradientUnits: "userSpaceOnUse",
    id: "c",
    x1: 25.719,
    x2: 104.844,
    xlinkHref: "#a",
    y1: 251.688,
    y2: 373.656
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M469.219 6.813H12.344l228.437 263.78L469.22 6.814z",
    style: {
      fontFamily: "Sans",
      fill: "#c42730"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.25 573.031c2.66-4.613 5.851-8.847 10-12.375 9.42-8.009 23.007-12.531 42.563-12.531H448.03c10.632 0 17.205-1.312 20.938-4.719 3.733-3.406 5.75-9.774 5.75-21.968V14.25L245.25 279.156v293.875z",
    style: {
      fontFamily: "Sans",
      fill: "#183883"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.813 14.219v507.219c0 12.196 2.058 18.564 5.78 21.968 3.723 3.404 10.244 4.719 20.876 4.719h150.219c19.555 0 33.142 4.522 42.562 12.531 4.13 3.512 7.315 7.723 9.969 12.313l.031-293.844L6.812 14.219z",
    style: {
      fontFamily: "Sans",
      fill: "#0093dd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.813 14.219 236.25 279.125l-.031 293.844c1.721 2.976 3.255 6.075 4.531 9.375 1.267-3.277 2.794-6.354 4.5-9.313V279.156L474.719 14.25V6.812h-5.5L240.78 270.594 12.344 6.813H6.813v7.406z",
    style: {
      fontFamily: "Sans",
      fill: "#d4af38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-742.553-305.326-6.841 5.887 236.256 272.785-.042 314.082h9.04v-314.04l236.296-272.827-6.841-5.887-233.934 270.13-233.934-270.13z",
    style: {
      fontFamily: "Sans",
      fill: "#fff"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-749.376-305.782v521.437c0 12.943 2.098 21.63 7.96 26.993 5.864 5.362 14.352 6.51 25.5 6.51h150.22c18.52 0 30.2 4.148 38.146 10.904 7.947 6.757 12.438 16.421 15.632 28.236l3.275 12.15 3.276-12.15c3.194-11.815 7.685-21.48 15.632-28.236 7.946-6.756 19.626-10.905 38.145-10.905h150.22c11.149 0 19.627-1.15 25.5-6.51 5.874-5.359 8.003-14.047 8.003-26.992v-521.437zm6.8 6.8h467.909v514.637c0 12.195-2.03 18.57-5.764 21.976-3.732 3.406-10.307 4.727-20.938 4.727h-150.22c-19.556 0-33.121 4.512-42.541 12.521-6.81 5.79-11.269 13.298-14.513 21.685-3.243-8.387-7.702-15.895-14.512-21.685-9.42-8.009-22.985-12.521-42.54-12.521h-150.22c-10.632 0-17.176-1.323-20.898-4.727-3.722-3.404-5.763-9.78-5.763-21.976z",
    style: {
      fontFamily: "Sans",
      fill: "#d4af38"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-568.077 50.094-.995 1.078-2.57 24.588-21.354 9.163h20.4l-1.285 12.563-22.225 8.459h21.312l-1.368 12.977-24.92 8.003h24.09l-3.897 37.461-5.639 22.162h3.276l15.175-11.402 15.134 11.402h3.317l-5.514-22.162-4.022-37.461h24.09l-24.92-8.003-1.368-12.978h21.354l-22.266-8.458-1.285-12.563h20.441l-21.395-9.163-2.57-24.588zm0 10.614.705 6.925h-1.41zm-.912 8.915h1.825l.58 5.349h-2.985zm.912 6.634 1.659.663.705 6.552h-4.727l.705-6.552zm-3.773 1.493-.622 6.22h-15.134zm7.546 0 15.798 6.22h-15.176zm-5.473 7.712h3.4l-1.7 2.736zm-1.078 1.99 1.617 2.654-2.28 3.69zm5.556 0 .664 6.344-2.28-3.69zm-2.778 4.52 2.737 4.436-2.737-.539-2.736.54zm0 5.721 3.98.913.664 6.426h-9.288l.664-6.426zm-6.012 1.659-.622 5.68h-15.673zm12.024 0 16.295 5.68h-15.673zm-9.95 6.593h7.877l-3.939 4.27zm-.996 1.865 3.608 3.856-4.478 4.893zm9.868 0 .415 4.105.456 4.644-4.478-4.893zm-4.934 5.35 4.312 4.643-4.312-.912-4.312.912zm0 5.016 6.178 1.824.664 6.096h-13.683l.663-6.096zm-8.25 2.446-.581 5.474h-17.912zm16.501 0 18.493 5.474h-17.912zM-575 126.925h13.849l.663 6.51-7.588 8.458-7.587-8.5zm-.954 9.08 6.593 7.34-8.334 9.287zm15.756.124 1.7 16.461-8.21-9.205zm-7.836 8.708 9.91 11.07.87 8.168h-21.602l.83-8.043zm-8.873 21.229h17.663l-8.832 6.634zm-2.488.58 9.536 7.173-14.138 10.78zm22.639 0 4.602 17.954-14.139-10.78z",
    style: {
      fontFamily: "Sans",
      fill: "#fff"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-711.538 31.56v36.695l84.46 125.135h20.524v-8.873h-9.578l-66.59-98.64 15.673 5.804 60.495 92.836 5.805 8.873h12.19v-7.92h-6.386L-653.2 96.823l18.658 6.924 54.068 89.643h10.49v-6.966h-5.1l-50.75-79.443 11.568 4.27 49.962 82.139h6.759v-6.137h-6.385l-45.693-79.152V86.996L-711.538 31.56z",
    style: {
      fill: "url(#c)"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-614.262 111.251v-23.15l-12.94-6.83v25.182zm-40.43-44.49v29.5l20.168 7.477V77.406zm-37.152-19.609v35.335l24.797 9.193V60.24z",
    style: {
      fill: "#cfcfcd"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-696.902 39.52v4.976l-1.617-.87h-3.649v24.421l80.77 116.47h5.266L-691.844 72.4V52.789l5.764 3.027v-5.598l23.51 12.398v22.473l65.303 100.672 2.322-.29-58.255-88.648 6.634 2.446-8.127-10.822V72.401l1.493.83v-5.64l21.501 11.307v25.888l53.547 81.638h3.068l-50.75-79.443 5.473 2.032-6.842-9.62V86.79h1.368v-4.77l13.228 6.955v17.476l47.433 80.802h1.244l-45.693-79.152V86.996z",
    style: {
      fill: "#666"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-711.538 68.255V193.39h84.46z",
    style: {
      fill: "#c1c1c1"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-652.513-40.896 10.174-5.196h13.784l41.035-23.692s15.915-5.436 19.445 0c2.418 3.722-5.414 12.165-5.414 12.165l-44.078 25.449-20.257 35.085-17.281 9.978 10.299-28.658-24.93 13.715s-6.567 3.54-10.588 2.87c-9.891-1.648-14.719-13.154-26.219-21.025 0 0-4.972 5.359-9.298 7.958 0 0 .25-7.59 4.356-10.89l-7.372-2.495s5.613-5.772 14.576-4.523c9.123 1.27 21.455 15.361 33.816 8.19l25.994-15.077c-3.653.336-5.646-2.094-8.042-3.854z",
    style: {
      fill: "url(#d)"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-432.032-79.588c25.651 3.336 30.778 9.752 46.236 17.08 7.092-.863 16.08-.315 21.277 2.848-.7 3.856-.984 8.009-4.691 9.717 7.707 7.54 15.675 14.752 23.12 22.618 1.375 1.452-1.703 2.362-3.35 2.848 4.117 2.876 8.836 5.352 11.727 9.047 18.931 1.424 24.46 7.036 24.46 7.036-9.01 1.684-20.061 8.434-20.775 21.78-2.822-1.528-8.235-9.53-16.418-24.46-2.958.885-5.265 1.786-7.455.083-7.342-5.708-15.464-10.962-24.042-15.33 0 0-2.45 4.172-3.102 8.378-.71 4.58-5.647-4.432-6.95-11.895-39.93-19.182-49.071-35.916-50.763-43.811-1.422-6.634 6.039-6.549 10.726-5.94z",
    style: {
      fill: "url(#e)"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-442.527-78.026a.597.597 0 0 0-.124 1.119c2.852 1.534 5.109 4.326 5.888 8.293a.597.597 0 1 0 1.16-.208c-.842-4.29-3.305-7.462-6.468-9.163a.597.597 0 0 0-.456-.041zm12.86 1.243c-.896 0-1.659.764-1.659 1.659s.763 1.617 1.659 1.617c.895 0 1.617-.722 1.617-1.617s-.722-1.659-1.617-1.659z",
    style: {
      fontFamily: "Sans"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#f)"
    },
    transform: "scale(-1 1) rotate(-45.673 -11.634 1042.662)",
    d: "M486.628 165.035h9.154v148.071h-9.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#g)"
    },
    transform: "rotate(-45.673 737.758 -736.88)",
    d: "M-224.038-555.287h9.154v141.675h-9.154z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-481.564-256.832 39.535 40.475c1.808.484 4.775.761 5.989-1.794l-3.795-23.333-28.026-28.693z",
    style: {
      fill: "url(#h)"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533.89-215.288h50.54l7.266 19.538h-65.073z",
    style: {
      fill: "url(#i)"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-550.685-242.372c.516 3.868 3.3 8.089 3.3 8.089l-6.396 6.548c.03.03-2.767-1.753-11.275-4.787-9.788-3.49-25.028 36.654-28.742 37.623-1.938-6.62 11.738-38.553 25.835-51.671 14.453-13.448 38.915-26.481 54.74-22.606-12.815 8.561-38.194 21.318-37.462 26.804z",
    style: {
      fill: "url(#j)"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-499.659-193.813h50.541l7.266 19.538h-65.073z",
    style: {
      fill: "url(#k)"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-568.126-193.974h50.541l7.266 19.538h-65.073z",
    style: {
      fill: "url(#l)"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-532.377-63.97 17.041 23.716h6.717l-23.592-23.592-.166-.124zm23.758 23.716 23.551-23.592-23.55 16.875v6.717zm0 0 23.717 23.717-17-23.717h-6.717zm0 0L-532.21-16.66l23.592-16.876v-6.717z",
    style: {
      fill: "#d4af38"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-532.357-16.514 23.737-23.737-6.716-.003zm47.475-.005-23.737-23.737-.003 6.716zm-.005-47.475-23.737 23.737 6.716.003zm-47.472.003 23.737 23.737.003-6.716z",
    style: {
      fill: "gold"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-508.619-87.397-6.675 40.468 6.675 6.675v-47.143zm0 47.143h47.144l-40.468-6.675-6.676 6.675zm0 0V6.89l6.676-40.468-6.676-6.676zm0 0h-47.143l40.468 6.676 6.675-6.676z",
    style: {
      fill: "#d4af38"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-555.755-40.254h47.133l-6.665-6.665zm47.133 47.133v-47.133l-6.665 6.666zm47.133-47.133h-47.133l6.666 6.666zm-47.133-47.133v47.133l6.666-6.665z",
    style: {
      fill: "gold"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-432.032 18.518c25.651 3.336 30.778 9.752 46.236 17.08 7.092-.863 16.08-.315 21.277 2.848-.7 3.856-.984 8.01-4.691 9.717 7.707 7.54 15.675 14.752 23.12 22.618 1.375 1.453-1.703 2.363-3.35 2.848 4.117 2.876 8.836 5.352 11.727 9.047 18.931 1.424 24.46 7.036 24.46 7.036-9.01 1.684-20.061 8.434-20.775 21.78-2.822-1.528-8.235-9.53-16.418-24.46-2.958.885-5.265 1.786-7.455.083-7.342-5.708-15.464-10.962-24.042-15.33 0 0-2.45 4.172-3.102 8.378-.71 4.581-5.647-4.432-6.95-11.895-39.93-19.182-49.071-35.916-50.763-43.81-1.422-6.635 6.039-6.55 10.726-5.94z",
    style: {
      fill: "url(#m)"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-442.527 20.08a.597.597 0 0 0-.124 1.12c2.852 1.533 5.109 4.325 5.888 8.292a.597.597 0 1 0 1.16-.208c-.842-4.29-3.305-7.462-6.468-9.163a.597.597 0 0 0-.456-.041zm12.86 1.244c-.896 0-1.659.763-1.659 1.658 0 .895.763 1.617 1.659 1.617.895 0 1.617-.722 1.617-1.617s-.722-1.658-1.617-1.658z",
    style: {
      fontFamily: "Sans"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-432.032 116.624c25.651 3.336 30.778 9.753 46.236 17.08 7.092-.863 16.08-.315 21.277 2.849-.7 3.855-.984 8.008-4.691 9.717 7.707 7.539 15.675 14.75 23.12 22.617 1.375 1.453-1.703 2.363-3.35 2.848 4.117 2.876 8.836 5.352 11.727 9.047 18.931 1.424 24.46 7.036 24.46 7.036-9.01 1.684-20.061 8.434-20.775 21.78-2.822-1.527-8.235-9.53-16.418-24.46-2.958.885-5.265 1.787-7.455.084-7.342-5.709-15.464-10.963-24.042-15.33 0 0-2.45 4.171-3.102 8.377-.71 4.581-5.647-4.432-6.95-11.895-39.93-19.182-49.071-35.916-50.763-43.81-1.422-6.635 6.039-6.55 10.726-5.94z",
    style: {
      fill: "url(#n)"
    },
    transform: "translate(749.394 305.782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-442.527 118.186a.597.597 0 0 0-.124 1.12c2.852 1.533 5.109 4.325 5.888 8.292a.597.597 0 1 0 1.16-.207c-.842-4.29-3.305-7.463-6.468-9.164a.597.597 0 0 0-.456-.041zm12.86 1.244c-.896 0-1.659.763-1.659 1.658 0 .895.763 1.617 1.659 1.617.895 0 1.617-.722 1.617-1.617s-.722-1.658-1.617-1.658z",
    style: {
      fontFamily: "Sans"
    },
    transform: "translate(749.394 305.782)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagadan);
export default __webpack_public_path__ + "static/media/magadan.3980642ff6295ccbd2f71272d4e9f5d3.svg";
export { ForwardRef as ReactComponent };